import { VehicleInfo } from "../VehicleSummaryCard/types";

import { VEHICLE_WIZARD_DEFAULT_IMAGE, VEHICLE_WIZARD_SAMPLE } from "./consts";

/** Naziv vozila iz odabira (proizvođač i model), ili primjer dok nije odabrano. */
export const getVehicleName = (vehicleInfo: VehicleInfo) =>
  [vehicleInfo.vehicleManufacturerName, vehicleInfo.vehicleModelName].filter(Boolean).join(" ") ||
  VEHICLE_WIZARD_SAMPLE.name;

export const getVehicleImage = (vehicleInfo: VehicleInfo) =>
  vehicleInfo.vehicleImage || VEHICLE_WIZARD_DEFAULT_IMAGE;

export const getVehiclePlate = (vehicleInfo: VehicleInfo) =>
  vehicleInfo.registrationPlate || VEHICLE_WIZARD_SAMPLE.plate;
